import { ApiError, createApiClient } from '../shared/http/ApiClient.js';
import type { RouteLoader } from '../shared/ssr/RouteLoader.js';
import { notFoundResult } from '../notfound/notfound.loader.js';
import type { NotFoundData } from '../notfound/notfound.loader.js';
import { headDeCategoria } from './categoria.head.js';
import { CategoriaRepository } from './models/repositories/CategoriaRepository.js';
import type { CategoriaData } from './models/entities/CategoriaData.js';
import { CACHE_TAG, categoryTag } from '@ahora-patagonia/contracts';

export const CATEGORIA_ROUTE_KEY = 'categoria';

/**
 * Loader de la página de sección. `?page=` es parte de la URL (indexable): la página 2 de
 * una sección grande existe para el crawler aunque el lector use "Ver más".
 *
 * Una sección archivada o inexistente es el mismo 404 con datos. Una sección **vacía** no:
 * su página existe, con el estado vacío (la que no se dibuja es su franja en la home).
 */
export const categoriaLoader: RouteLoader<CategoriaData | NotFoundData> = async (ctx) => {
  const urlKey = ctx.params['categoria'] ?? '';
  const page = Math.max(1, Number(ctx.query['page']) || 1);

  const api = createApiClient({
    baseUrl: process.env['SSR_API_URL'] ?? 'http://localhost:3000',
    headers: { host: ctx.headers['host'] ?? '' },
  });

  let data: CategoriaData;
  try {
    data = await new CategoriaRepository(api).porUrlKey(urlKey, page);
  } catch (err) {
    if (err instanceof ApiError && err.status === 404) return notFoundResult(ctx);
    throw err;
  }

  return {
    data,
    head: headDeCategoria(data.category, ctx.site, page),
    cache: {
      sMaxAge: 120,
      staleWhileRevalidate: 300,
      tags: [categoryTag(data.category.id), CACHE_TAG.shell, CACHE_TAG.ads],
      visibility: 'public',
    },
  };
};
